export const navigationLinks = [
  {
    name: 'Home',
    ref: '#home'
  },
  {
    name: 'About me',
    ref: '#about-me'
  },
  {
    name: 'Technologies',
    ref: '#technologies'
  },
  {
    name: 'Projects',
    ref: '#portfolio'
  },
  {
    name: 'Contact me',
    ref: '#contact'
  },
  {
    name: 'CV',
    ref: 'https://drive.google.com/file/d/1ZzUPCtwc4-XbVJKhvG45HIQrIqcDuSzP/view?usp=share_link'
  }
]